import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Sintija
 * id D92E7B40-A6F6-479D-9FFD-807AE3E470E6
 * name format-paragraph-spacing
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-paragraph-spacing.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatParagraphSpacingIcon = createSvgIcon(<><path d="M3 17H21V19H3V17M3 2H21V4H3V2M3 20H21V22H3V20M13 8H15L12 5L9 8H11V13H9L12 16L15 13H13V8Z" /></>, 'FormatParagraphSpacingIcon');
export default FormatParagraphSpacingIcon